import { endOfDay } from "date-fns";

import { APPOINTMENT_TYPE_GENERAL_TYPE_FITTING } from "constants/appointment-types";
import {
  APPOINTMENT_STATUS_ARRIVED,
  APPOINTMENT_STATUS_COMPLETED,
  APPOINTMENT_STATUS_CONFIRMED
} from "constants/appointments";
import { useGetPatientAppointmentsQuery } from "services/appointments";
import type { TinyAppointment } from "services/types/appointments.type";

import { convertDateInTimezoneToCurrent } from "utils/common";

export const FITTING_DELIVERY_STATUSES = [
  APPOINTMENT_STATUS_ARRIVED,
  APPOINTMENT_STATUS_CONFIRMED,
  APPOINTMENT_STATUS_COMPLETED
];

const FITTING_APPOINTMENTS_QUERY =
  "{id,start_moment,end_moment,status,staff_member{id,first_name,last_name,suffix,title,is_active},clinic{id,name,timezone},type{id,name,default_duration,general_type}}";

export function usePatientFittingAppointments(
  patientId?: number | string,
  options?: { skip?: boolean }
) {
  const skip = Boolean(options?.skip) || !patientId;

  const {
    data: appointments = [],
    isLoading,
    isSuccess
  } = useGetPatientAppointmentsQuery(
    {
      patientId: Number(patientId),
      appointment_type_general_type: Number(
        APPOINTMENT_TYPE_GENERAL_TYPE_FITTING
      ),
      baseFilter: { status: FITTING_DELIVERY_STATUSES },
      upToDate: endOfDay(new Date()).toISOString(),
      limit: 300,
      query: FITTING_APPOINTMENTS_QUERY
    },
    { skip }
  );

  const mostRecent: TinyAppointment | null = appointments[0] ?? null;

  return { appointments, mostRecent, isLoading, isSuccess };
}

export function appointmentToDeliveryDate(
  appointment?: TinyAppointment | null
): Date | null {
  if (!appointment?.startDate) return null;
  return convertDateInTimezoneToCurrent(
    appointment.startDate,
    appointment.clinic?.timezone
  );
}
